/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any).process = {
  env: {},
  version: '',
  platform: 'browser',
  nextTick: function(fn: any, ...args: any[]) {
    setTimeout(() => fn(...args), 0);
  }
};
(window as any).global = window;
(window as any).Buffer = {
  isBuffer: () => false
};
if (typeof (window as any).util === 'undefined') {
  (window as any).util = {
    inherits: function(ctor: any, superCtor: any) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    },
    deprecate: function(fn: any) { return fn; },
    isArray: Array.isArray,
    isBoolean: (arg: any) => typeof arg === 'boolean',
    isNull: (arg: any) => arg === null,
    isNullOrUndefined: (arg: any) => arg == null,
    isNumber: (arg: any) => typeof arg === 'number',
    isString: (arg: any) => typeof arg === 'string',
    isSymbol: (arg: any) => typeof arg === 'symbol',
    isUndefined: (arg: any) => arg === void 0,
    isRegExp: (re: any) => Object.prototype.toString.call(re) === '[object RegExp]',
    isObject: (arg: any) => typeof arg === 'object' && arg !== null,
    isDate: (d: any) => Object.prototype.toString.call(d) === '[object Date]',
    isError: (e: any) => Object.prototype.toString.call(e) === '[object Error]' || e instanceof Error,
    isFunction: (arg: any) => typeof arg === 'function',
    isPrimitive: (arg: any) => arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined',
    format: function(...args: any[]) { return args.join(' '); }
  };
}
